import React from 'react';
import { Menu, X, Search, Phone } from 'lucide-react';
import Container from './Container';
import Button from './Button';

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const navLinks = [
    { href: '#products', label: 'Products' },
    { href: '#case-studies', label: 'Case Studies' },
    { href: '#pricing', label: 'Pricing' },
    { href: '#contact', label: 'Contact' }
  ];

  return (
    <nav className="fixed w-full bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
      <Container>
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <Search className="h-8 w-8 text-blue-600" />
            <span className="ml-2 text-xl font-bold text-gray-900">RoofersWantSEO</span>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map(link => (
              <a 
                key={link.href} 
                href={link.href} 
                className="text-gray-700 hover:text-blue-600"
              >
                {link.label}
              </a>
            ))}
            <a 
              href="tel:9192714871" 
              className="flex items-center text-blue-600 hover:text-blue-700 font-semibold"
            >
              <Phone className="h-5 w-5 mr-2" />
              (919) 271-4871
            </a>
            <Button withArrow>Get Started</Button>
          </div>

          <button 
            className="md:hidden"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </Container>

      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navLinks.map(link => (
              <a 
                key={link.href}
                href={link.href} 
                className="block px-3 py-2 text-gray-700"
              >
                {link.label}
              </a>
            ))}
            <a 
              href="tel:9192714871" 
              className="flex items-center px-3 py-2 text-blue-600"
            >
              <Phone className="h-5 w-5 mr-2" />
              (919) 271-4871
            </a>
            <Button className="w-full mt-4" withArrow>Get Started</Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;